import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { findLang } from '../../../common/models/lang';
import { EXTERNAL_LINKS } from '../../../constants';

// Consent by button text (spec decision 3). `actionKey` names the button:
// 'signupForm.consentSignup' (informational) or 'signupForm.consentSet' (binding).
const ConsentNote = ({ actionKey, sx = {} }) => {
    const { t, i18n } = useTranslation();
    const links = EXTERNAL_LINKS[findLang(i18n.language).i18nCode];
    const link = (href, label) => (
        <Typography
            variant="caption"
            component="a"
            sx={{ color: 'primary.main' }}
            href={href}
            rel="noopener noreferrer"
            target="_blank"
        >
            {label}
        </Typography>
    );
    return (
        <Typography variant="caption" component="div" sx={{ textAlign: 'center', ...sx }}>
            <span>{t(actionKey)}</span> {link(links.terms, t('signupForm.consentTerms'))} {t('signupForm.consentAnd')}{' '}
            {link(links.policy, t('signupForm.consentPolicy'))}
            {t('signupForm.consentEnd')}
        </Typography>
    );
};

export { ConsentNote };
